<template>
  <v-container class="guide-container" fluid>
    <div class="main-content">
      <v-row justify="center" align="center">
        <v-col cols="12">
          <h1 class="title text-center">網站導覽</h1>
          <!-- 調整為左對齊並加粗 -->
          <p class="paragraph bold-text">本網站依「無障礙網頁設計原則」建置，包括：</p>
          <ul class="list">
            <li>所有的頁面都可以用鍵盤操作，不限於使用滑鼠。</li>
            <li>網站設置網頁定位點（:::），使用者可快速到達各主要區塊。</li>
            <li>網頁圖片均標示適當的替代文字說明。</li>
            <li>在介面變更、變更網址或開新視窗的連結項目上加上提示文字，使用者不需一一前往連結頁面即可知道每一個連結的目的。</li>
          </ul>
          <p class="paragraph bold-text">本網站主要內容分為三大區塊：</p>
          <ul class="list">
            <li>（1）上方功能區塊</li>
            <li>（2）中央內容區塊</li>
            <li>（3）下方功能區塊</li>
          </ul>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'Application',
};
</script>

<style scoped>
.guide-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0; /* 上下內邊距 */
}

.main-content {
  max-width: 960px; /* 設定最大寬度，增加左右邊界 */
  width: 100%;
  padding: 20px; /* 上下左右內邊距 */
  margin: 0 5%; /* 左右邊界設定 */
  box-shadow: 0 0 0 1px #ccc; /* 添加邊界線，模擬頁面邊界 */
  background-color: #f9f9f9; /* 背景顏色，讓內容更突出 */
}

.title {
  font-size: 2rem; /* 標題字體大小 */
  font-weight: bold; /* 標題加粗 */
  margin-bottom: 1.5rem; /* 下方間距 */
  text-align: center; /* 標題居中 */
}

.paragraph {
  font-size: 1.2rem; /* 段落字體大小 */
  line-height: 1.8; /* 行高 */
  margin-bottom: 1.2rem; /* 下方間距 */
  text-align: left; /* 段落左對齊 */
  font-weight: normal; /* 預設為正常字重 */
}

.bold-text {
  font-weight: bold; /* 加粗 */
}

.list {
  list-style-type: disc; /* 圓點符號 */
  margin: 1rem 0 1.5rem 2rem; /* 調整上下間距和左側間距 */
  font-size: 1.2rem; /* 清單字體大小，與段落一致 */
  line-height: 1.8; /* 行高，與段落一致 */
  text-align: left; /* 清單左對齊 */
  font-weight: normal; /* 清單正常字重 */
}

li {
  margin-bottom: 0.8rem; /* 調整清單項目的間距 */
}
</style>
